<template>
  <!-- <pre v-if="responseData">  test data :: {{ responseData }}</pre>  -->
  <Background v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/SPAH,CERUN,JALAN.png"
        alt="SPAH,CERUN,JALAN"
        class="pbt-image"
      />

      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="spah">
        <div class="spah-container">
          <img
            src="@/assets/spah/bangunan.png"
            alt="First Image"
            class="responsive-image"
          />
          <div class="text-overlay-right custom-position-1">
            <div class="values-layered">
              <h3>
                BILANGAN BANGUNAN
                <span class="tooltip-container">
                  (SPAH)
                  <span class="tooltip-icon">ℹ️</span>
                  <span class="tooltip-text"
                    >Sistem Pengumpulan dan Penggunaan Semula Air Hujan</span
                  >
                </span>
              </h3>
              <p class="number">
                {{ overallData.bilangan_keseluruhan_bangunan }}
              </p>
              <Update />
            </div>
          </div>
        </div>

        <div class="spah-container">
          <img
            src="@/assets/spah/cerun.png"
            alt="Second Image"
            class="responsive-image"
          />
          <div class="text-overlay-left custom-position-2">
            <div class="values-layered">
              <h3>JUMLAH CERUN</h3>
              <p class="number">
                {{ jumlahCerun }}
              </p>
              <Update />
            </div>
          </div>
        </div>

        <div class="spah-container">
          <img
            src="@/assets/spah/jalan.png"
            alt="Third Image"
            class="responsive-image"
          />
          <div class="text-overlay-right custom-position-3">
            <div class="values-layered">
              <h3>PANJANG JALAN DI PBT</h3>
              <p class="number">{{ numberWithCommas(panjangJalan) }} KM</p>
              <Update />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from "@/components/background/background.vue";
import Menu from "@/components/menu-items/utama-menu.vue";
import { useHttpService } from "@/httpService";
import { onMounted, ref } from "vue";

definePage({
  alias: "/pages/pages/inspektorat/ahli-pbt",
  meta: {
    layout: "blank",
    public: true,
  },
});

const {
  loading,
  error,
  httpDelete,
  httpPostPut,
  httpGet,
  httpPost,
  numberWithCommas,
  formatToMillion,
} = useHttpService();

const spah = ref({
  spah: {
    bilangan_keseluruhan_bangunan: 0,
  },
});

const responseData = ref(null);
const overallData = ref();
const jumlahCerun = ref();
const panjangJalan = ref();

async function loadDataFromApi() {
  try {
    const spahResponse = await httpGet("kejuruteraan-awam/spah");
    const cerunResponse = await httpGet("kejuruteraan-awam/cerun?year=2025");
    const jalanResponse = await httpGet("kejuruteraan-awam/jalan");

    responseData.value = {
      spah: spahResponse.data,
      cerun: cerunResponse.data,
      jalan: jalanResponse.data,
    };

    overallData.value = spahResponse.data.spah;
    jumlahCerun.value = cerunResponse.data.jumlah_cerun;
    panjangJalan.value = jalanResponse.data.panjang_jalan.toFixed(2);

    spah.value.spah = {
      bilangan_keseluruhan_bangunan:
        overallData.value.bilangan_keseluruhan_bangunan,
    };
  } catch (err) {
    console.error("loadDataFromApi failed:", err);
  }
}

onMounted(() => {
  loadDataFromApi();
});
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: help;
}

.tooltip-icon {
  margin-left: 4px;
  font-size: 0.6em;
}

.tooltip-text {
  visibility: hidden;
  color: #000000;
  text-align: right;
  padding: 6px 10px;
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  bottom: 80%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 0.7rem;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%);
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%;
  height: auto;
}

.line-under-image {
  width: 70%;
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

.spah {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.spah-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay-left,
.text-overlay-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #ffffff;
  font-family: Arial, sans-serif;
}

.text-overlay-left {
  left: 15%;
  text-align: left;
}

.text-overlay-right {
  right: 15%;
  text-align: right;
}

.values-layered {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.values-layered h3 {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 38px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.text {
  font-size: 18px;
  font-weight: bold;
  color: #150069;
  text-align: center;
}

.custom-position-1 {
  top: 50%;
}

.custom-position-2 {
  top: 50%;
}

.custom-position-3 {
  top: 50%;
}

@media (max-width: 768px) {
  .text-overlay-left h3,
  .text-overlay-right h3 {
    font-size: 18px;
  }

  .values-layered .number,
  .values-layered .text {
    font-size: 16px;
  }

  .content-wrapper {
    padding: 15px;
  }

  .text-overlay-left {
    left: 10%;
  }

  .text-overlay-right {
    right: 10%;
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 20px;
  }

  .text-overlay-left h3,
  .text-overlay-right h3 {
    font-size: 12px;
  }

  .values-layered {
    gap: 5px;
  }

  .text-overlay-left {
    left: 5%;
  }

  .text-overlay-right {
    right: 5%;
  }
}
</style>
